import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";
import {BannerModel} from "@white-label/components/page-builder/models/banner.model";

export class CarouselModel {
    banners = new EditableFieldModel('banners', FieldType.array, [], BannerModel);
    duration = new EditableFieldModel('duration', FieldType.number, 2);
    fieldsMap = [this.banners, this.duration];
    constructor(data?: {banners?: any, duration?: any}) {
        if(data?.banners){
            this.banners.value = [];
            for(let banner of data?.banners.value){
                this.banners.value.push(new BannerModel(banner));
            }
        }
        if(data?.duration){
            this.duration.value = data.duration.value;
        }
    }
}